<template>
	<div id="page-arrow-prev" class="page-arrow" v-bind:class="`page-arrow-${className}`" v-if="linkPrev">
		<router-link v-bind:to="linkPrev" class="arr" v-bind:class="questionPopupDisplay ? 'question-present': ''">
			<img width="34" src="../assets/navigation/arrow-left.png" alt="Prev" />
		</router-link>
	</div>
	<div id="page-arrow-next" class="page-arrow" v-bind:class="`page-arrow-${className}`" v-if="linkNextInterim">
		<div v-on:click="loadInterim" class="arr" v-bind:class="questionPopupDisplay ? 'question-present': ''">
			<img width="34" src="../assets/navigation/arrow-right.png" alt="Next" />
		</div>
	</div>
	<div id="page-arrow-next" class="page-arrow" v-bind:class="`page-arrow-${className}`" v-if="linkNext && !linkNextInterim">
		<router-link v-bind:to="linkNext" class="arr" v-bind:class="questionPopupDisplay ? 'question-present': ''">
			<img width="34" src="../assets/navigation/arrow-right.png" alt="Next" />
		</router-link>
	</div>
</template>
<script>
export default {
	emits: ['load-interim'],
	props: {
		className: {
			type: String
		},
		linkPrev: {
			type: String
		},
		linkNext: {
			type: String
		},
		linkNextInterim: {
			type: Boolean
		},
		questionPopupDisplay: {
			type: Boolean
		}
	},
	methods: {
		loadInterim(){
			this.$emit('load-interim','question-popup')
		}
	},
}
</script>
<style scoped>
.page-arrow > div {
	cursor: pointer;
}

#page-arrow-prev {
	margin-top: 42px;
	position: absolute;
	transform: translateY(-50%);
	top: 50%;
}

	#page-arrow-prev .arr {
		display: block;
		padding: 48px 15px 48px 0;
	}

	#page-arrow-prev {
		left: 0;
	}

#page-arrow-next {
	margin-top: 42px;
	position: absolute;
	transform: translateY(-50%);
	top: 50%;
}

	#page-arrow-next .arr {
		display: block;
		padding: 48px 0 48px 15px;
	}

	#page-arrow-next {
		right: 0;
	}

#page-arrow-prev.page-arrow-patient,
#page-arrow-next.page-arrow-patient {
	margin-top: 0;
	transform: translateY(-117%);
}

#page-arrow-prev.page-arrow-patient.final {
	transform: translateY(-98.5%);
}

.question-present {
	opacity: .33;
}
</style>